import { Box, Paper, Stack, Typography } from '@mui/material';
import { authHighlights } from './constants';

function AuthLayout({ children }) {
  return (
    <Box className="auth-page">
      <Paper className="auth-shell" elevation={0}>
        <Box className="auth-showcase">
          <Stack className="auth-showcase-content" spacing={4}>
            <Stack spacing={1.5}>
              <Typography className="auth-eyebrow" variant="overline">
                ta2shera.com
              </Typography>
              <Typography variant="h3">
                Your time belongs to travel, not visa paperwork.
              </Typography>
            </Stack>

            <Stack spacing={1.5}>
              {authHighlights.map((item) => (
                <Stack className="auth-highlight" direction="row" key={item.title} spacing={1.5}>
                  <Box className="auth-highlight-bullet" />
                  <Typography className="auth-highlight-title" variant="body1">
                    {item.title}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Box>

        <Box className="auth-form-panel">
          <Paper className="auth-card" elevation={0}>
            {children}
          </Paper>
        </Box>
      </Paper>
    </Box>
  );
}

export default AuthLayout;
